import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ISetDisplayTabsParams {
  ids: string[];
  displayTabs: boolean;
}

export interface ISetDisplayTabsResult extends IResult {
}

export class SetDisplayTabsRequest extends Request<ISetDisplayTabsParams, ISetDisplayTabsResult> {
  constructor(params: ISetDisplayTabsParams) {
    super('setDisplayTabs', params);
  }
}
